import { UserInput } from 'src/modules/user-input/types.ts';
import { numberFormatter } from 'src/utils/numberFormatter.ts';
import { LocalesEnum } from 'src/generated/operations.ts';

export const getUserInputValue = (inputState: UserInput, t: (key: string) => string, locale: LocalesEnum) => {
    const data = [
        ...(inputState.kvs.length > 0 ? [[inputState.kvs, inputState.kvs_u]] : []),
        ...(inputState.v100.length > 0 && inputState.kvs.length === 0 ? [[inputState.v100, inputState.v100_u]] : []),
    ];
    return data.length === 0 ? '-' : data
        .map(([value, unit]) => `${numberFormatter(value, locale)} ${
            t(unit)
        }`).join(', ');
};
